var ProgressionsTelemetryMetricNames = /* @__PURE__ */ ((ProgressionsTelemetryMetricNames2) => {
  ProgressionsTelemetryMetricNames2["Feature_AutomaticTriggerredStateAction_Edit"] = "Feature_AutomaticTriggerredStateAction_Edit";
  ProgressionsTelemetryMetricNames2["Feature_AutomaticTriggerredStateAction_Create"] = "Feature_AutomaticTriggerredStateAction_Create";
  ProgressionsTelemetryMetricNames2["FeatureProgression_GetRootFeatureGatesTenantName"] = "FeatureProgression_GetRootFeatureGatesTenantName";
  return ProgressionsTelemetryMetricNames2;
})(ProgressionsTelemetryMetricNames || {});
export {
  ProgressionsTelemetryMetricNames
};
//# sourceMappingURL=ProgressionsTelemetryMetricNames.js.map
